import React, { useState } from "react";

import { getCurrentPlatformTermsAndConditions } from "services";

import { saveFile, useTranslation } from "utils";

import { Anchor, Button, Drawer, LazyLoadImage, SocialShareButtons, Steps, Message as message } from "components";

export const ReferralDrawer = ({ firstYearlyDataReferralValue, referralToken, referralValue, visible, onClose }) => {
  const { t } = useTranslation("user");

  const [showMobileShareButtons, setShowMobileShareButtons] = useState(false);

  const handlePlatformTermsClick = async () => {
    const data = await getCurrentPlatformTermsAndConditions();
    saveFile(data, `${t("terms.terms")}.pdf`);
  };

  const showButton = (navigator && navigator.share) || (window.cordova && window.cordova.plugins.socialsharing);

  const handleShare = ({ title, link }) => {
    if (window.cordova && window.cordova.plugins.socialsharing) {
      return window.cordova.plugins.socialsharing.shareWithOptions(
        {
          url: link,
          message: title,
          subject: title,
        },
        () => {
          message({ content: t("share.successful"), icon: "tick" });
        },
        () => {
          setShowMobileShareButtons(true);
          message({ content: t("share.failed"), icon: "error" });
        }
      );
    }

    if (navigator && navigator.share) {
      return navigator
        .share({
          title: title,
          url: link,
        })
        .then(() => {
          message({ content: t("share.successful"), icon: "tick" });
        })
        .catch((_err) => {
          setShowMobileShareButtons(true);
          message({ content: t("share.failed"), icon: "error" });
        });
    }

    setShowMobileShareButtons(true);
  };

  const steps = [
    {
      key: 0,
      title: t("referralDrawer.shareLink"),
      description: (
        <>
          <div className="step-description">{t("referralDrawer.step1")}</div>
          {!showButton || showMobileShareButtons ? (
            <SocialShareButtons text={t("referralDrawer.sharingText")} url={`${process.env.REACT_APP_FARM_URL}?referrer=${referralToken}`} />
          ) : (
            <Button
              type="primary"
              block
              onClick={() =>
                handleShare({
                  title: t("referralDrawer.sharingText"),
                  link: `${process.env.REACT_APP_FARM_URL}?referrer=${referralToken}`,
                })
              }
            >
              {t("referralDrawer.sendInvitation")}
            </Button>
          )}
        </>
      ),
      status: "process",
    },
    {
      key: 1,
      title: t("referralDrawer.earnCredits"),
      description: (
        <>
          <div className="step-description">
            {t("referralDrawer.step2", {
              referralValueFirst: referralValue,
              referralValueSecond: firstYearlyDataReferralValue,
              referralValueSum: referralValue + firstYearlyDataReferralValue,
            })}
          </div>
          <Anchor onClick={handlePlatformTermsClick}>{t("referralDrawer.termsAndConditions")}</Anchor>
        </>
      ),
      status: "process",
    },
  ];

  return (
    <Drawer className="referral-drawer" visible={visible} title={t("referralDrawer.title")} onClose={onClose}>
      <section className="center">
        <LazyLoadImage alt="" src="/images/misc/friendly_farmers.jpg" />
        <h2>
          {t("referralDrawer.description", {
            referralValueFirst: referralValue,
            referralValueSecond: firstYearlyDataReferralValue,
            referralValueSum: referralValue + firstYearlyDataReferralValue,
          })}
        </h2>
        <Steps items={steps} className="referral-steps" />
      </section>
    </Drawer>
  );
};
